import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-gotx-news',
  templateUrl: './gotx-news.component.html',
  styleUrls: ['./gotx-news.component.scss']
})
export class GotxNewsComponent implements OnInit {

  @Input('data') data: any[];
  constructor() { }

  ngOnInit() {
  }
}
